/**
 * @param  {*} x value
 * @return {boolean} isTrue
 *
 * @since 4.0.0-alpha.1
 * @memberOf is
 * @func isTrue
 *
 * @example
 *
 *  isTrue(true)
 *  //=> true
 *  isTrue(false)
 *  //=> false
 *  isTrue(1)
 *  //=> false
 *  isTrue('')
 *  //=> false
 *
 */
module.exports = function (x) { return x === true; }

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJ1ZS5qcyIsInNvdXJjZXMiOlsidHJ1ZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIEBwYXJhbSAgeyp9IHggdmFsdWVcbiAqIEByZXR1cm4ge2Jvb2xlYW59IGlzVHJ1ZVxuICpcbiAqIEBzaW5jZSA0LjAuMC1hbHBoYS4xXG4gKiBAbWVtYmVyT2YgaXNcbiAqIEBmdW5jIGlzVHJ1ZVxuICpcbiAqIEBleGFtcGxlXG4gKlxuICogIGlzVHJ1ZSh0cnVlKVxuICogIC8vPT4gdHJ1ZVxuICogIGlzVHJ1ZShmYWxzZSlcbiAqICAvLz0+IGZhbHNlXG4gKiAgaXNUcnVlKDEpXG4gKiAgLy89PiBmYWxzZVxuICogIGlzVHJ1ZSgnJylcbiAqICAvLz0+IGZhbHNlXG4gKlxuICovXG5tb2R1bGUuZXhwb3J0cyA9IHggPT4geCA9PT0gdHJ1ZVxuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQW9CQSxNQUFNLENBQUMsT0FBTyxHQUFHLFVBQUEsQ0FBQyxDQUFBLENBQUMsQUFBRyxTQUFBLENBQUMsS0FBSyxJQUFJLEdBQUE7In0=